export default "__VITE_ASSET__BuM_zxzM__"